var _slicedToArray = require("/home/circleci/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
var _require = require('ramda'),
  map = _require.map,
  compose = _require.compose,
  join = _require.join,
  toPairs = _require.toPairs,
  filter = _require.filter,
  trim = _require.trim;
var DEFAULT_EMPLOYMENT_FILTERS = 'employment_type:\'Year Round\' OR employment_type:\'Part Time\'';
var filtersBuilder = {
  categories: function categories(_categories) {
    return _categories.length ? "(".concat(compose(join(' OR '), map(function (category) {
      return "job_category:'".concat(category, "'");
    }))(_categories), ")") : '';
  },
  salaryRange: function salaryRange(_ref) {
    var baseCompMin = _ref.baseCompMin;
    return baseCompMin ? "(annual_compensation_min.value >= ".concat(baseCompMin, " OR annual_compensation_max.value >= ").concat(baseCompMin, ")") : '';
  },
  locations: function locations(_locations) {
    return _locations.length ? "(".concat(compose(join(' OR '), map(function (location) {
      return "facilities.state_name:'".concat(trim(location.code), "' OR other_states:'").concat(trim(location.code), "'");
    }))(_locations), ")") : '';
  },
  seasonal: function seasonal(_seasonal) {
    return _seasonal ? "(employment_type:Seasonal OR employment_type:seasonal OR ".concat(DEFAULT_EMPLOYMENT_FILTERS, ")") : "(".concat(DEFAULT_EMPLOYMENT_FILTERS, ")");
  },
  excludeProOnly: function excludeProOnly(shouldExclude) {
    return shouldExclude ? '(NOT applicant_group: \'PGA Professional Only\')' : '';
  }
};
var buildFiltersFrom = compose(join(' AND '), filter(trim), map(function (_ref2) {
  var _ref3 = _slicedToArray(_ref2, 2),
    paramKey = _ref3[0],
    paramValue = _ref3[1];
  return filtersBuilder[paramKey](paramValue);
}), toPairs);
var buildAlgoliaQuery = function buildAlgoliaQuery(_ref4) {
  var queryParams = _ref4.queryParams,
    created = _ref4.created,
    _ref4$hitsPerPage = _ref4.hitsPerPage,
    hitsPerPage = _ref4$hitsPerPage === void 0 ? 10 : _ref4$hitsPerPage;
  var filters = buildFiltersFrom(queryParams);
  if (filters === "(".concat(DEFAULT_EMPLOYMENT_FILTERS, ")")) return null;
  return {
    hitsPerPage: hitsPerPage,
    page: 0,
    attributesToRetrieve: ['jobId', 'jobTitle', 'created', 'facilities', 'job_category', 'base_compensation', 'current_step'],
    responseFields: '*',
    filters: "".concat(filters, " ").concat(filters ? 'AND' : '', " submission_deadline > ").concat(Date.now() / 1000, " AND current_step:\"complete\" ").concat(created ? "AND (created > ".concat(created, " OR mgmt_job_go_live_datetime > ").concat(created, ")") : '')
  };
};
module.exports = {
  buildAlgoliaQuery: buildAlgoliaQuery,
  buildFiltersFrom: buildFiltersFrom,
  filtersBuilder: filtersBuilder
};